import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { preset } from 'vue-cli-plugin-vuetify-preset-reply/preset'

Vue.use(Vuetify);

export default new Vuetify({
  preset,
	theme: {
		dark: false,
		themes: {
			light: {
				primary: '#00387A',
				secondary: '#FF9500',
				accent: '#FFE473',
				error: '#FF5252',
				info: '#B2C2D6',
				success: '#4CAF50',
				warning: '#FFC107',
			}
		}
	},
});